<template>
    <div>

        <containerHeader ref="header"></containerHeader>

        <div class="content" style="margin: 20px;">
            <div class="upper">
                <div class="panel-item" style="height: 300px;flex: 1;">
                    <div class="panel-title" style="margin-bottom: 10px" >
                        健康状态分布
                    </div>
                    <div ref="pieChart" style="height: 250px;width: 100%;"/>
                    <div class="panel-footer"/>
                </div>
                <div class="panel-item" style="height: 300px;flex: 1;margin: 0 10px">
                    <div class="panel-title" style="margin-bottom: 10px" >
                        异常类型分布
                    </div>
                    <div ref="pieChart2" style="height: 250px;width: 100%;"/>
                    <div class="panel-footer"/>
                </div>
                <div class="panel-item" style="height: 300px;flex: 1;">
                    <div class="panel-title" style="width: 300px; margin-bottom: 10px" >
                        最近6个月预警
                    </div>
                    <div ref="lineChart" style="height: 250px;width: 100%;"/>
                    <div class="panel-footer"/>
                </div>
            </div>

            <div class="down panel-item" style="height: 500px;margin-top: 10px">
                <div class="panel-title" style="margin-bottom: 10px" >
                    健康指数
                </div>
                <div v-for="item in elevatorList" class="item-box" :class="{warning: (item.id>=20 && item.id<30),health:item.id<20,error:item.id>=30}" style="text-align: center">
                    <div style="font-size: 35px;margin-top: 10px;font-family: fx-led;color: white">{{100-item.id}}</div>
                    <div style="font-size: 16px;color: white;margin-top: 10px;">{{item.remark}}</div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    import * as echarts from "echarts";
    import containerHeader from "../components/container_header.vue";
    export default {
        name: "analysis",
        components:{
            containerHeader
        },
        data(){
          return{
              elevatorList:[]

          }
        },
        mounted() {
            this.getElevatorList();
            this.initChart();
            this.initChart2();
            this.initLineChart();
        },
        methods:{
            getElevatorList() {
                const params = {};
                this.$api.elevator.list(params).then((res) => {
                    if (res.success) {
                        this.elevatorList = res.data;
                        console.log('elevatorList',res.data);
                    }
                });
            },
            initLineChart(){
              let chart = echarts.init(this.$refs.lineChart);
              let option = {
                    color: ['#80FFA5', '#00DDFF', '#37A2FF', '#FF0087', '#FFBF00'],
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'cross',
                            label: {
                                backgroundColor: '#6a7985'
                            }
                        }
                    },
                    grid: {
                        left: '3%',
                        right: '4%',
                        bottom: '8%',
                        containLabel: true,
                    },
                    xAxis: [
                        {
                            type: 'category',
                            boundaryGap: false,
                            data: ['2022-11', '2022-12', '2023-01', '2023-02', '2023-03', '2023-04'],
                            axisLabel: {
                                color: 'white'
                            },
                            splitLine: {
                                show: false
                            },
                            axisTick: {
                                alignWithLabel: true
                            }
                        }
                    ],
                    yAxis: [
                        {
                            type: 'value',
                            minInterval: 100,
                            splitLine: {show: false},
                            axisLabel: {
                                color: 'white'
                            }
                        }
                    ],
                    series: [
                        {
                            name: 'Line 1',
                            type: 'line',
                            stack: 'Total',
                            smooth: true,
                            // lineStyle: {
                            //     width: 0
                            // },
                            showSymbol: false,
                            areaStyle: {

                                opacity: 0.8,
                                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                    {
                                        offset: 0,
                                        color: 'rgb(128, 255, 165)'
                                    },
                                    {
                                        offset: 1,
                                        color: 'rgb(1, 191, 236)'
                                    }
                                ])
                            },
                            emphasis: {
                                focus: 'series'
                            },
                            data: [232, 101, 264, 90, 340, 250]
                        }


                    ]
                };
                chart.setOption(option);
                //随着屏幕大小调节图表
                window.addEventListener("resize", () => {
                    chart.resize();
                });
            },
            initChart() {
                let getchart = echarts.init(this.$refs.pieChart);
                let option = {
                    title: {
                        show: false
                    },
                    tooltip: {
                        trigger: 'item'
                    },
                    legend: {
                        orient: 'vertical',
                        left: 'left',
                        show: false
                    },
                    darkMode: true,
                    series: [
                        {
                            type: 'pie',
                            radius: ['40%', '70%'],
                            data: [
                                { value: 8, name: '健康', itemStyle:{color:'rgb(87,165,64)'} },
                                { value: 2, name: '亚健康', itemStyle:{color:'rgb(250,200,88)'} },
                                { value: 1, name: '危险', itemStyle:{color:'rgb(238,102,102)'}  },
                            ],
                            emphasis: {
                                itemStyle: {
                                    shadowBlur: 10,
                                    shadowOffsetX: 0,
                                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                                }
                            }
                        }
                    ]
                };

                getchart.setOption(option);
                //随着屏幕大小调节图表
                window.addEventListener("resize", () => {
                    getchart.resize();
                });
            },
            initChart2() {
                let getchart = echarts.init(this.$refs.pieChart2);
                let option = {
                    title: {
                        show: false
                    },
                    tooltip: {
                        trigger: 'item'
                    },
                    legend: {
                        orient: 'vertical',
                        left: 'left',
                        show: false
                    },
                    darkMode: true,
                    series: [
                        {
                            type: 'pie',
                            radius: ['40%', '70%'],
                            data: [
                                { value: 8, name: '制动器异常' },
                                { value: 2, name: '曳引电机异常'},
                                { value: 3, name: '轿厢速度异常' },
                                { value: 5, name: '倾角异常' },
                                { value: 25, name: '门异常' },
                            ],
                            emphasis: {
                                itemStyle: {
                                    shadowBlur: 10,
                                    shadowOffsetX: 0,
                                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                                }
                            }
                        }
                    ]
                };

                getchart.setOption(option);
                //随着屏幕大小调节图表
                window.addEventListener("resize", () => {
                    getchart.resize();
                });
            },

        }

    }
</script>

<style scoped>

    .content{

    }

    .upper{
        display: flex;
    }

    .health{
        background-color: rgb(87,165,64);
    }
    .warning{
        background-color: rgb(178,112,17);
    }

    .error{
        background-color: rgb(238,102,102);
    }

    .panel-item {
        /*box-shadow: inset 0px 0px 16px 4px rgba(0, 162, 255, 0.54);*/
        padding: 1.25rem;
        border: 1px solid rgba(25, 186, 139, 0.17);
        background-color: rgba(9, 20, 40, 0.5);
        /*background-color: rgba(255, 255, 255, 0.04);*/

        position: relative;
        width: 100%;
        box-sizing: border-box;
        overflow: hidden;
    }


    .panel-item::before {
        position: absolute;
        top: 0;
        left: 0;
        content: "";
        width: 15px;
        height: 15px;
        border-top: 1px solid #02a6b5;
        border-left: 1px solid #02a6b5;
        transition: all 0.5s;
    }

    .panel-item::after {
        position: absolute;
        top: 0;
        right: 0;
        content: "";
        width: 15px;
        height: 15px;
        border-top: 1px solid #02a6b5;
        border-right: 1px solid #02a6b5;
        transition: all 0.5s;
    }

    .panel-footer::before {
        position: absolute;
        bottom: 0;
        left: 0;
        content: "";
        width: 15px;
        height: 15px;
        border-bottom: 1px solid #02a6b5;
        border-left: 1px solid #02a6b5;
        transition: all 0.5s;
    }


    .panel-footer::after {
        position: absolute;
        bottom: 0;
        right: 0;
        content: "";
        width: 15px;
        height: 15px;
        border-bottom: 1px solid #02a6b5;
        border-right: 1px solid #02a6b5;
    }

    .item-box{
        height: 100px;
        width: 200px;
        margin: 0 5px 5px 0;
        float: left;
        cursor: pointer;
    }
    .item-box:hover{
        opacity: 0.8;
    }
</style>



// WEBPACK FOOTER //
// src/pages/analysis.vue